import md5 from 'md5';
import localStorage from '@/common/utils/storage';

/**
 * 记录课程学习进度
 */
class CourseProgress {
  makeKey (userId) {
    return `course-progress-${md5(userId)}`;
  }

  updateProgress (userId, postId, progress) {
    const storageKey = this.makeKey(userId);
    const value = localStorage.get(storageKey) || '';
    let obj = {};
    try {
      obj = {
        ...obj,
        ...JSON.parse(value)
      };
    } catch (e) {
      // do nothing
    }
    obj[postId] = progress;

    localStorage.set(storageKey, JSON.stringify(obj));
  }

  getProgress (userId) {
    const storageKey = this.makeKey(userId);
    const value = localStorage.get(storageKey) || '';
    let obj = {};
    try {
      obj = {
        ...obj,
        ...JSON.parse(value)
      };
    } catch (e) {
      // do nothing
    }
    return obj;
  }
}

export default new CourseProgress();
